// ScrollContext.js
import React from "react";

// 创建一个上下文对象
const ScrollContext = React.createContext();

// 导出上下文的提供者组件
export const ScrollProvider = ScrollContext.Provider;
// 导出一个自定义钩子，用于在组件中使用上下文
export const useScrollContext = () => React.useContext(ScrollContext);
